<template>
  <div class="body-row quality">
    <div class="body-row-left" v-text="label"></div>
    <div class="body-row-right">
      <div class="stars">
        <div class="star" :class="{ 'rfp-rr-rating-rtl-float-right': rtl }" tabindex="0">
          <vue-star-rating
            :increment="increment"
            :max-rating="maxRating"
            :inactive-color="inactiveColor"
            :active-color="activeColor"
            :star-size="starSize"
            :show-rating="false"
            :rating="value"
            @rating-selected="hndChange"
            @update:rating="hndChange"
          ></vue-star-rating>
        </div>
      </div>
      <div class="star-label" v-text="options[itoa[value]]"></div>
      <p
        v-if="validationError"
        class="Refapp-ratings-validation-error"
        v-text="validationErrorMessage"
      ></p>
    </div>
  </div>
</template>

<script>
import VueStarRating from 'vue-star-rating';

export default {
  name: 'rfp-ratings-write-optional-stars',
  components: {
    VueStarRating,
  },
  inject: ['increment', 'maxRating', 'inactiveColor', 'activeColor', 'starSize'],
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => {},
    },
    rtl: {
      type: Boolean,
      default: false,
    },
    validationError: {
      type: [String, null],
      default: null,
    },
    validationErrorMessage: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  created() {
    // converts a numeric 1-5 into one, two..etc gods have mercy on who came up with this keying
    this.itoa = {
      0: 'default',
      1: 'one',
      2: 'two',
      3: 'three',
      4: 'four',
      5: 'five',
    };
  },
  methods: {
    // we opted to use manual event emission as v-model is broken between vue 2 and 3
    hndChange(newValue) {
      this.$emit('update', newValue);
    },
  },
};
</script>
